<template>
  <div class="topic">
    <div class="left">
      <div class="menu">
        <p :class="select === 1 ? 'select' : ''" @click="select = 1">
          <img src="https://img2.233.com/wx/union/pure/pc/blue/tk_ic_2.png" v-if="skinColor === 'blue'" />
          <img src="https://img2.233.com/wx/union/pure/pc/green/tk_ic_2.png" v-else-if="skinColor === 'green'" />
          <img src="https://img2.233.com/wx/union/pure/pc/red/tk_ic_2.png" v-else />
          <span>模拟考场</span>
        </p>
        <p :class="select === 2 ? 'select' : ''" @click="select = 2">
          <img src="https://img2.233.com/wx/union/pure/pc/blue/tk_ic_3.png" v-if="skinColor === 'blue'" />
          <img src="https://img2.233.com/wx/union/pure/pc/green/tk_ic_3.png" v-else-if="skinColor === 'green'" />
          <img src="https://img2.233.com/wx/union/pure/pc/red/tk_ic_3.png" v-else />
          <span>历年真题</span>
        </p>
        <p @click="$emit('openLink', 3)">
          <img src="https://img2.233.com/wx/union/pure/pc/blue/tk_ic_4.png" v-if="skinColor === 'blue'" />
          <img src="https://img2.233.com/wx/union/pure/pc/green/tk_ic_4.png" v-else-if="skinColor === 'green'" />
          <img src="https://img2.233.com/wx/union/pure/pc/red/tk_ic_4.png" v-else />
          <span>章节练习</span>
        </p>
        <p @click="$emit('openLink', 7)">
          <img src="https://img2.233.com/wx/union/pure/pc/blue/tk_ic_5.png" v-if="skinColor === 'blue'" />
          <img src="https://img2.233.com/wx/union/pure/pc/green/tk_ic_5.png" v-else-if="skinColor === 'green'" />
          <img src="https://img2.233.com/wx/union/pure/pc/red/tk_ic_5.png" v-else />
          <span>每日一练</span>
        </p>
      </div>
      <div class="details">
        <div class="item" v-for="item in curList" :key="item.PaperId">
          <div class="text">
            <p>{{ item.PaperName }}</p>
            <span>{{ item.DoExamCount }}人在做</span>
          </div>
          <a class="button" @click="openLink(item)">免费做题</a>
        </div>
        <div class="not-data" v-if="curList.length === 0">
          <img src="https://img2.233.com/wx/union/pure/pc/none_ic.png" />
          <p>Sorry，暂无试题，我们正在努力添加中…</p>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="name">
        <span>配套赠送题库</span>
        <label>专业智能，高效提分</label>
      </div>
      <div class="bottom">
        <label>专业解析</label>
        <p>
          每道题
          <span>配有专业答案解析</span>
          解密题目背后的考点逻辑
        </p>
        <label>助教答疑</label>
        <p>
          <span>专业助教答疑服务</span>
          做题不留任何疑问
        </p>
        <label>全真机考</label>
        <p>
          <span>全真机考系统免费开放</span>
          避免正式机考操 作失误
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { getTikuPath } from "@/utils";

export default {
  name: "Topic",
  props: {
    topicList: {
      type: Array,
      default: () => []
    },
    skinColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      select: 1
    };
  },
  computed: {
    curList() {
      return this.topicList.filter((item) => (this.select === 1 && item.PaperType === 3) || (this.select === 2 && item.PaperType === 2));
    }
  },
  methods: {
    openLink(item) {
      const url = getTikuPath(8, {}, item.PaperId);
      window.open(url);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/css/index.scss";
.topic {
  display: flex;
  justify-content: space-between;
  margin: 0 auto 34px;
  width: 1200px;
  .left {
    width: 895px;
    height: 348px;
    display: flex;
    .menu {
      width: 200px;
      p {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 80px;
        background: linear-gradient(90deg, #ffffff, #f3f4f5);
        margin-top: 12px;
        box-sizing: border-box;
        cursor: pointer;
        img {
          width: 41px;
          height: 41px;
          margin-right: 12px;
        }
        span {
          font-size: 20px;
          font-weight: 400;
          color: #343434;
          display: inline-block;
        }
        &:nth-child(1),
        &:nth-child(2) {
          margin-top: 0;
          background: white;
          border-right: 1px solid #ebebeb;
          span {
            color: #565656;
            font-weight: bold;
          }
        }
        &:nth-child(1) {
          border-bottom: 1px solid #ebebeb;
        }
      }
      .select {
        @include topic_select_border_left();
        span {
          @include topic_select_color();
        }
      }
    }
    .details {
      background: white;
      padding: 0 30px;
      flex: 1;
      overflow-y: auto;
      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 30px 0 32px;
        border-bottom: 1px solid #e7e7e7;
        &:nth-last-child(1) {
          border-bottom: none;
        }
        .text {
          flex: 1;
          p {
            color: #343434;
            font-size: 17px;
            font-weight: 400;
            margin-bottom: 10px;
          }
          span {
            color: #9a9a9a;
            font-size: 14px;
            font-weight: 400;
          }
        }
        .button {
          display: inline-block;
          font-size: 17px;
          color: white;
          font-weight: 400;
          width: 113px;
          height: 35px;
          line-height: 35px;
          text-align: center;
          margin-left: 50px;
          @include topic_button();
          border-radius: 18px;
          cursor: pointer;
          text-decoration: none;
          cursor: pointer;
        }
      }
      .not-data {
        display: flex;
        height: 100%;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        img {
          width: 120px;
          height: 97.72px;
        }
        p {
          font-size: 15px;
          font-weight: 400;
          color: #878787;
          line-height: 30px;
          margin-top: 16px;
        }
      }
    }
  }
  .right {
    width: 290px;
    height: 348px;
    background: white;
    padding: 5px 15px;
    box-sizing: border-box;
    .name {
      border-bottom: 1px solid #e8e8e8;
      line-height: 60px;
      span {
        color: #b58b4a;
        font-size: 18px;
        font-weight: bold;
        margin-right: 23px;
      }
      label {
        font-size: 14px;
        color: #888;
        font-weight: 400;
      }
    }
    .bottom {
      label {
        margin: 12px 0;
        color: white;
        font-size: 15px;
        font-weight: 400;
        height: 19px;
        line-height: 19px;
        display: inline-block;
        padding: 0 2px;
        background: #c5944c;
        background: linear-gradient(90deg, #c5944c, #d9b373);
        box-shadow: 1px 5px 21px 0px rgba(197, 150, 58, 0.33);
      }
      p {
        margin-bottom: 14px;
        color: #565656;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        span {
          color: #343434;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
